import React, { useState, useEffect } from "react";
import "../WithdrawalStyle.css";
import { apiAppFetch } from '../utils/apiFetch';
import { PaymentGatewayPayout, fetchPaymentGatewayConfig } from '../modules/paymentGateway';

const Withdrawal = () => {    
  const user_id = Number(localStorage.getItem('userId'));

  const [userData, setUserData] = useState({
    clientId: "",
    parentId: "",
    clientName: "",
    phoneNumber: "",
    supportContact: "",
    withdrawContact: "",
    address: "",
    mainAmount: "0",
    marginUsed: "0",
    marginAvailable: "0",
    availableMargin: "0",
    bank: {
      accountHolderName: "",
      accountNumber: "",
      aacountType: "SAVING",
      IFSC: "",
      bank: "",
      branch: "",
      upiHandle: ""
    }
  });

  const [formData, setFormData] = useState({
    name: "",
    userId: "",
    phone: "",
    amount: "",
    remark: "",
  });

  const [bankDetails, setBankDetails] = useState({
    bank: "",
    branch: "",
    accountHolderName: "",
    accountNumber: "",
    reAccountNumber: "",
    ifsc: "",
    accountType: "",
    upiHandle: ""
  });

  const [amountInWords, setAmountInWords] = useState("");
  const [hasPositions, setHasPositions] = useState(false);
  const [numberOfPositions, setNumberOfPositions] = useState(0);
  const [isEditingBankDetails, setIsEditingBankDetails] = useState(false);
  const [pgConfig, setPgConfig] = useState({
    payoutEnabled: false,
    manualWithdrawEnabled: true,
  });

  const getUserDetails = async () => {
    try {  
      const response = await apiAppFetch('getUserDetails', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      
      const data = await response.json();
      
      // Store complete user data
      setUserData({
        clientId: data.clientId,
        parentId: data.parentId,
        clientName: data.clientName,
        phoneNumber: data.phoneNumber,
        supportContact: data.supportContact,
        withdrawContact: data.withdrawContact,
        address: data.address,
        mainAmount: data.mainAmount,
        marginUsed: data.marginUsed,
        marginAvailable: data.marginAvailable,
        availableMargin: data.availableMargin,
        bank: {
          accountHolderName: data.accountHolderName,
          accountNumber: data.accountNumber,
          aacountType: data.aacountType,
          IFSC: data.IFSC,
          bank: data.bank,
          branch: data.branch,
          upiHandle: data.upiHandle
        }
      });

      // Update form data
      setFormData(prevFormData => ({
        ...prevFormData,
        name: data.clientName,
        userId: data.clientId,
        phone: data.phoneNumber
      }));

      // Update bank details
      setBankDetails({
        bank: data.bank,
        branch: data.branch,
        accountHolderName: data.accountHolderName,
        accountNumber: data.accountNumber,
        reAccountNumber: data.accountNumber,
        ifsc: data.IFSC,
        accountType: data.aacountType,
        upiHandle: data.upiHandle
      });

    } catch (error) {
      console.error('Error fetching user details:', error);
    }
  };

  const getPortfolio = async () => {
    try {
      const response = await apiAppFetch('portfolio', {
        method: 'POST',
        body: JSON.stringify({}),
      });
      
      const data = await response.json();
      
      if (data && data.length > 0) {
        setHasPositions(true);
        setNumberOfPositions(data.length);
      }

    } catch (error) {
      console.error('Error fetching portfolio:', error);
    }
  };

  useEffect(() => {
    getUserDetails();
    getPortfolio();
    fetchPaymentGatewayConfig()
      .then((data) => {
        setPgConfig({
          payoutEnabled: Boolean(data.payoutEnabled),
          manualWithdrawEnabled: data.manualWithdrawEnabled !== false,
        });
      })
      .catch(() => {
        setPgConfig({ payoutEnabled: false, manualWithdrawEnabled: true });
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));

    if (name === 'amount') {
      const words = convertToWords(value);
      setAmountInWords(words);
    }
  };

  const handleBankDetailsChange = (e) => {
    const { name, value } = e.target;
    setBankDetails(prev => ({ ...prev, [name]: value }));
  };

  const convertToWords = (num) => {
    const a = ['','one ','two ','three ','four ', 'five ','six ','seven ','eight ','nine ','ten ','eleven ','twelve ','thirteen ','fourteen ','fifteen ','sixteen ','seventeen ','eighteen ','nineteen '];
    const b = ['', '', 'twenty','thirty','forty','fifty', 'sixty','seventy','eighty','ninety'];
    
    if ((num = num.toString()).length > 9) return 'overflow';
    const n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; 
    
    let str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
    return str;
  };

  const handleWithdrawalRequest = () => {
    if (!userData.withdrawContact) {
      alert("Withdrawal contact not available. Please contact support.");
      return;
    }

    const message = `I want to withdraw ₹${formData.amount}\nMy Client ID: ${formData.userId}\nClient Name: ${formData.name}\nBank: ${bankDetails.bank}\nBank account: ${bankDetails.accountNumber}\nIFSC: ${bankDetails.ifsc}\nRemark: ${formData.remark}`;
    const phoneNumber = userData.withdrawContact;
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleUpdateBankDetails = async () => {
    try {
      if (bankDetails.accountNumber !== bankDetails.reAccountNumber) {
        alert("Account numbers do not match!");
        return;
      }

      const response = await apiAppFetch('updateBankDetails', {
        method: 'POST',
        body: JSON.stringify({
          accountHolderName: bankDetails.accountHolderName,
          accountNumber: bankDetails.accountNumber,
          aacountType: bankDetails.accountType,
          IFSC: bankDetails.ifsc,
          bank: bankDetails.bank,
          branch: bankDetails.branch,
          upiHandle: bankDetails.upiHandle,
        }),
      });

      const data = await response.json();
      if (!data.success) {
        alert(data.message);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.error('Error updating bank details:', error);
      alert("Error updating bank details");
    }
  };

  return (
    <div style={styles.container}>
      <PaymentGatewayPayout
        user={{
          clientId: formData.userId,
          clientName: formData.name,
          name: formData.name,
          phoneNumber: formData.phone,
          phone: formData.phone,
        }}
        bankDetails={bankDetails}
        hasPositions={hasPositions}
        availableBalance={userData.mainAmount}
      />

      {pgConfig.manualWithdrawEnabled !== false && (
      <div style={styles.row}>
        {/* Withdrawal Form Section */}
        <div style={styles.withdrawalContainer}>
          <div style={styles.card}>
            <h2 style={styles.heading}>{pgConfig.payoutEnabled ? 'Request via support' : 'Payment Withdraw Form'}</h2>
            <hr/>
            
            {hasPositions && (
              <div style={styles.warning}>
                You can't withdrawal amount, you have {numberOfPositions} active position{numberOfPositions > 1 ? "s" : ""} in portfolio.
                <br/>
                <a href="/portfolio" style={styles.warningLink}>Go to Portfolio.</a>
              </div>
            )}

            <form style={styles.form}>
              <div style={styles.row}>
                <div style={styles.inputGroup}>
                  <label>Name</label>
                  <input 
                    type="text" 
                    name="name" 
                    value={formData.name} 
                    readOnly 
                    style={styles.inputDisabled} 
                  />
                </div>
                <div style={styles.inputGroup}>
                  <label>User ID</label>
                  <input 
                    type="text" 
                    name="userId" 
                    value={formData.userId} 
                    readOnly 
                    style={styles.inputDisabled} 
                  />
                </div>
              </div>

              <div style={styles.inputGroup}>
                <label>Phone</label>
                <input 
                  type="text" 
                  name="phone" 
                  value={formData.phone} 
                  readOnly 
                  style={styles.inputDisabled} 
                />
              </div>

              <div style={styles.inputGroup}>
                <label>Amount</label>
                <input 
                  type="number" 
                  name="amount" 
                  value={formData.amount} 
                  onChange={handleChange} 
                  disabled={hasPositions}
                  required 
                  style={styles.input} 
                  min="1"
                />
                {amountInWords && <div style={styles.amountText}>{amountInWords}</div>}
              </div>

              <div style={styles.inputGroup}>
                <label>Remark/UPI Id</label>
                <textarea 
                  name="remark" 
                  value={formData.remark} 
                  onChange={handleChange} 
                  disabled={hasPositions}
                  style={styles.textarea}
                ></textarea>
              </div>

              <button 
                type="button" 
                onClick={handleWithdrawalRequest} 
                disabled={hasPositions}
                style={styles.button}
              >
                Request
              </button>
            </form>
          </div>
        </div>
      </div>
      )}

      {/* Bank Details Section */}
      <div style={styles.bankDetailsContainer}>
        <div style={styles.card}>
          <div style={styles.bankDetailsHeader}>
            <h2 style={styles.heading}>Your Bank Details</h2>
            <button 
              type="button" 
              onClick={() => setIsEditingBankDetails(!isEditingBankDetails)}
              style={styles.editButton}
            >
              {isEditingBankDetails ? 'Cancel' : 'Edit Bank Details'}
            </button>
          </div>
          <hr/>
          <form style={styles.form}>
            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label>Bank</label>
                <input 
                  type="text" 
                  name="bank" 
                  value={bankDetails.bank} 
                  onChange={handleBankDetailsChange} 
                  readOnly={!isEditingBankDetails}
                  style={isEditingBankDetails ? styles.input : styles.inputDisabled} 
                />
              </div>
              <div style={styles.inputGroup}>
                <label>Branch</label>
                <input 
                  type="text" 
                  name="branch" 
                  value={bankDetails.branch} 
                  onChange={handleBankDetailsChange} 
                  readOnly={!isEditingBankDetails}
                  style={isEditingBankDetails ? styles.input : styles.inputDisabled} 
                />
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label>Account Holder Name</label>
              <input 
                type="text" 
                name="accountHolderName" 
                value={bankDetails.accountHolderName} 
                onChange={handleBankDetailsChange} 
                readOnly={!isEditingBankDetails}
                style={isEditingBankDetails ? styles.input : styles.inputDisabled} 
              />
            </div>

            <div style={styles.inputGroup}>
              <label>Account Number</label>
              <input 
                type="text" 
                name="accountNumber" 
                value={bankDetails.accountNumber} 
                onChange={handleBankDetailsChange} 
                readOnly={!isEditingBankDetails}
                style={isEditingBankDetails ? styles.input : styles.inputDisabled} 
              />
            </div>

            {isEditingBankDetails && (
              <div style={styles.inputGroup}>
                <label>Repeat Account Number</label>
                <input 
                  type="text" 
                  name="reAccountNumber" 
                  value={bankDetails.reAccountNumber} 
                  onChange={handleBankDetailsChange} 
                  style={styles.input} 
                />
              </div>
            )}

            <div style={styles.row}>
              <div style={styles.inputGroup}>
                <label>IFSC Code</label>
                <input 
                  type="text" 
                  name="ifsc" 
                  value={bankDetails.ifsc} 
                  onChange={handleBankDetailsChange} 
                  readOnly={!isEditingBankDetails}
                  style={isEditingBankDetails ? styles.input : styles.inputDisabled} 
                />
              </div>
              <div style={styles.inputGroup}>
                <label>Account Type</label>
                <select 
                  name="accountType" 
                  value={bankDetails.accountType} 
                  onChange={handleBankDetailsChange} 
                  disabled={!isEditingBankDetails}
                  style={isEditingBankDetails ? styles.input : styles.inputDisabled}
                >
                  <option value="">Select Account Type</option>
                  <option value="SAVING">SAVING</option>
                  <option value="CURRENT">CURRENT</option>
                </select>
              </div>
            </div>

            <div style={styles.inputGroup}>
              <label>UPI Handle</label>
              <input 
                type="text" 
                name="upiHandle" 
                value={bankDetails.upiHandle} 
                onChange={handleBankDetailsChange} 
                readOnly={!isEditingBankDetails}
                style={isEditingBankDetails ? styles.input : styles.inputDisabled} 
              />
            </div>

            {isEditingBankDetails && (
              <button 
                type="button" 
                onClick={handleUpdateBankDetails} 
                style={styles.button}
              >
                Update Bank Details
              </button>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: "95%",
    margin: "10px auto",
    // padding: "20px",
  },
  row: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    '@media (min-width: 992px)': {
      flexDirection: "row",
    }
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
    padding: "20px",
    marginBottom: "20px",
  },
  heading: {
    color: "#0D2563",
    fontSize: "20px",
    marginBottom: "10px",
    textAlign: "center",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "15px",
  },
  inputGroup: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: "10px",
  },
  input: {
    padding: "12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
  },
  inputDisabled: {
    padding: "12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    backgroundColor: "#f0f0f0",
    cursor: "not-allowed",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
  },
  textarea: {
    padding: "12px",
    borderRadius: "5px",
    border: "1px solid #ccc",
    height: "80px",
    width: "100%",
    boxSizing: "border-box",
    fontSize: "16px",
    resize: "vertical",
  },
  button: {
    padding: "12px 24px",
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "16px",
    width: "100%",
    marginTop: "10px",
    '&:disabled': {
      backgroundColor: "#ccc",
      cursor: "not-allowed",
    }
  },
  bankDetailsContainer: {
    width: "100%",
  },
  withdrawalContainer: {
    width: "100%",
  },
  warning: {
    backgroundColor: "#d56477",
    color: "white",
    padding: "10px",
    borderRadius: "5px",
    marginBottom: "20px",
    textAlign: "center",
    fontSize: "14px",
  },
  warningLink: {
    color: "white",
    textDecoration: "underline",
  },
  amountText: {
    marginTop: "5px",
    fontSize: "14px",
    color: "#666",
    textAlign: "left",
  },
  bankDetailsHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "10px",
  },
  editButton: {
    padding: "8px 16px",
    backgroundColor: "#6c757d",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
    fontSize: "14px",
  }
};

export default Withdrawal; 